import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import classNames from 'classnames';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_DEPOSIT_PROTECTION_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import { DSIcon } from '../../../base';

import FeatureBox from './FeatureBox';
import Point1Illustration from './Illustrations/Point1Illustration';
import Point2Illustration from './Illustrations/Point2Illustration';
import Point3Illustration from './Illustrations/Point3Illustration';

import styles from './DepositProtectionModal.module.scss';

const DEPOSIT_POINTS = [
  {
    title: trans('deposit-protected.modal.point-1.title'),
    content: trans('deposit-protected.modal.point-1.content'),
    renderImage: () => <Point1Illustration />
  },
  {
    title: trans('deposit-protected.modal.point-2.title'),
    content: trans('deposit-protected.modal.point-2.content'),
    renderImage: () => <Point2Illustration />
  },
  {
    title: trans('deposit-protected.modal.point-3.title'),
    content: trans('deposit-protected.modal.point-3.content'),
    renderImage: () => <Point3Illustration />
  }
];

const HOW_IT_WORKS = [
  'deposit-protected.modal.how-it-works.point-1',
  'deposit-protected.modal.how-it-works.point-2',
  'deposit-protected.modal.how-it-works.point-3'
];

const VariantLabel = () => (
  <span className={styles['deposit-protection-modal__header-label-with-icon']}>
    <DSIcon name="lock_closed" size="l" />
    {trans('listing.labels.deposit-protected.title')}
  </span>
);

const DepositProtectionModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_DEPOSIT_PROTECTION_MODAL
  });

  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  const featuresContainerClasses = classNames(
    styles['deposit-protection-modal__features'],
    {
      [styles[
        'deposit-protection-modal__features--simplification-header-variant'
      ]]: isListingSimplificationHeaderVariant
    }
  );

  const bodyClasses = classNames(styles['deposit-protection-modal__body'], {
    [styles['deposit-protection-modal__body--simplification-header-variant']]:
      isListingSimplificationHeaderVariant
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="medium"
      className={styles['deposit-protection-modal']}
    >
      <ModalHeader
        className={styles['deposit-protection-modal__header']}
        onRequestClose={handleModalClose}
        label={
          isListingSimplificationHeaderVariant ? (
            <VariantLabel />
          ) : (
            trans('listing.labels.deposit-protected.title')
          )
        }
      />
      <ModalBody className={bodyClasses}>
        <p className={styles['deposit-protection-modal__description']}>
          {isListingSimplificationHeaderVariant
            ? trans('deposit-protected.modal.description.variant')
            : trans('deposit-protected.modal.description')}
        </p>
        <div className={featuresContainerClasses}>
          {isListingSimplificationHeaderVariant && (
            <>
              <div>
                <h5
                  className={styles['deposit-protection-modal__feature-title']}
                >
                  {trans('deposit-protected.modal.how-it-works.title')}
                </h5>
                <ul>
                  {HOW_IT_WORKS.map(point => (
                    <li key={point}>{trans(point)}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h5
                  className={styles['deposit-protection-modal__feature-title']}
                >
                  {trans('deposit-protected.modal.what-if.title')}
                </h5>
                <p
                  className={
                    styles['deposit-protection-modal__feature-content']
                  }
                >
                  {trans('deposit-protected.modal.what-if.content')}
                </p>
              </div>
            </>
          )}
          {!isListingSimplificationHeaderVariant &&
            DEPOSIT_POINTS.map(point => (
              <FeatureBox
                key={point.title}
                title={trans(point.title)}
                content={trans(point.content)}
                renderImage={point.renderImage}
              />
            ))}
        </div>
      </ModalBody>
    </Modal>
  ) : null;
};

export default DepositProtectionModal;
